/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Model from 'can/model/model';
import Map from 'scripts/models/base/map';
import dtm from 'scripts/services/dtm';

export default Model.extend(
    {},
    {
        define: {
            fetching: {
                type: 'boolean',
                value: false,
            },
            standings: {
                Type: Map.List,
                Value: '*',
            },
            activeId: {
                type: 'string',
                value: null,
            },
            playersProbabilityLink: {
                value:
                    window.globalSettings.pagePaths.playerStatistics +
                    '#!&win-probability=1',
            },
            probabilityType: {
                type: 'string',
            },
            probabilityTypes: {
                type: 'array',
                value: null,
            },
            round: {
                type: 'number',
                value: null,
            },
            isNavOpen: {
                type: 'boolean',
                value: false,
            },
        },
        changeProbabilityType(probabilityType) {
            this.attr('isNavOpen', false);
            this.attr('probabilityType', probabilityType);
            dtm.trackWinProbabilityTrackerTabClick(probabilityType);
        },

        clickWinProbabilityLink(event) {
            event.preventDefault();
            dtm.trackBiggestMoversFullLeaderboardClick();
            window.open(this.attr('playersProbabilityLink'));
        },

        toggleNavOpen() {
            this.attr('isNavOpen', !this.attr('isNavOpen'));
        },
    },
);
